var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { getByIdAPI, getListAPI, setState, updateAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { AreaFieldReportsChildAndParentURL, AreaFieldReportsHistoryURL, AreaFieldReportsKeys, AreaFieldReportsPagingURL, AreaFieldFailureReportsDetailsURL, FieldFailureReportsHistoryURL, PriorityPickListURL, CategoryPickListURL, FieldFailureReportsChildURL, AreaFieldReportsUpdateURL, DealerIdListURL, FFRAreaRemarks, UpdateRemarks } from "./entity";
// import {  AreaFieldReportsCreateAttachment, AreaFieldReportsAttachmentSingleValue } from "./entity";
import { fieldFailureReportsDetailGetByIdAPI, fieldFailureReportsDetailUpdateByIdAPI, FieldFailureReportsKeys, fieldFailureReportsPagingURL } from "../../fieldFailureReports/services/entity";
import { showNotification } from "../../../redux/commonSlice";
import { createAPI } from "../../../redux/crudSlice";
import { getAreaFieldDashboard, getFFRCatalogue, getFieldFailureDashboard, updateDashboardCount, updateDashboardCountAFR } from "./entity";
var dispatch = store.dispatch;
export var FieldFailureDashboard = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, _d, responseFFR, responseAFR;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.getDashboard : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getFieldFailureDashboard : _c;
                return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: key,
                            request: request,
                            url: url
                        })), dispatch(getByIdAPI({
                            key: AreaFieldReportsKeys.getDashboardASMAFR,
                            request: request,
                            url: getAreaFieldDashboard
                        }))])];
            case 1:
                _d = _e.sent(), responseFFR = _d[0], responseAFR = _d[1];
                return [2 /*return*/, {
                        dashboardCountFFR: responseFFR,
                        dashboardCountAFR: responseAFR
                    }];
        }
    });
}); };
export var FFRCatalogue = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.getCatalogueFFR : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getFFRCatalogue : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var FFRCountApi = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _receivedRes$payload$, _receivedRes$payload, _revertedRes$payload$, _revertedRes$payload, _isolatedRes$payload$, _isolatedRes$payload, _a, receivedRes, revertedRes, isolatedRes, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: getFFRCatalogue,
                        request: {
                            status: "ReceivedToASM"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: getFFRCatalogue,
                        request: {
                            status: "ResentByASM"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: getFFRCatalogue,
                        request: {
                            status: "Isolated"
                        }
                    }))])];
            case 1:
                _a = _b.sent(), receivedRes = _a[0], revertedRes = _a[1], isolatedRes = _a[2];
                result = dispatch(setState({
                    key: AreaFieldReportsKeys.count,
                    value: {
                        received: (_receivedRes$payload$ = receivedRes === null || receivedRes === void 0 || (_receivedRes$payload = receivedRes.payload) === null || _receivedRes$payload === void 0 || (_receivedRes$payload = _receivedRes$payload.value) === null || _receivedRes$payload === void 0 ? void 0 : _receivedRes$payload.count) !== null && _receivedRes$payload$ !== void 0 ? _receivedRes$payload$ : 0,
                        reverted: (_revertedRes$payload$ = revertedRes === null || revertedRes === void 0 || (_revertedRes$payload = revertedRes.payload) === null || _revertedRes$payload === void 0 || (_revertedRes$payload = _revertedRes$payload.value) === null || _revertedRes$payload === void 0 ? void 0 : _revertedRes$payload.count) !== null && _revertedRes$payload$ !== void 0 ? _revertedRes$payload$ : 0,
                        isolated: (_isolatedRes$payload$ = isolatedRes === null || isolatedRes === void 0 || (_isolatedRes$payload = isolatedRes.payload) === null || _isolatedRes$payload === void 0 || (_isolatedRes$payload = _isolatedRes$payload.value) === null || _isolatedRes$payload === void 0 ? void 0 : _isolatedRes$payload.count) !== null && _isolatedRes$payload$ !== void 0 ? _isolatedRes$payload$ : 0
                    }
                }));
                return [2 /*return*/, result.payload.value];
        }
    });
}); };
export var getDashboardCount = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, _d, responseFFR, responseAFR;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.updateDashboardCount : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? updateDashboardCount : _c;
                return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: key,
                            request: request,
                            url: url
                        })), dispatch(getByIdAPI({
                            key: AreaFieldReportsKeys.updateDashboardCountAFR,
                            request: request,
                            url: updateDashboardCountAFR
                        }))])];
            case 1:
                _d = _e.sent(), responseFFR = _d[0], responseAFR = _d[1];
                return [2 /*return*/, {
                        dashboardCountFFR: responseAFR,
                        dashboardCountAFR: responseFFR
                    }];
        }
    });
}); };
export var AreaFieldReportsGetAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AreaFieldReportsGetAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                console.log("res?.payload?.value======.", res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.value) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.data);
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.value) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.data];
        }
    });
}); };
export var areaFieldFailureReportsGetAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _res$payload5, _res$payload6, _ChildAndParentData$p, _HistoryData$payload, _DealerIdList$payload, _a, key, _b, request, _c, url, req, HistoryReq, _d, res, ChildAndParentData, HistoryData, DealerIdList, FileAttachments;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AreaFieldFailureReportsDetailsURL(request === null || request === void 0 ? void 0 : request.id) : _c;
                req = {
                    ParentAFRId: request.id
                };
                HistoryReq = {
                    AFRReportId: request.id
                };
                return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: key,
                            url: url,
                            request: request
                        })), dispatch(getByIdAPI({
                            key: AreaFieldReportsKeys.getAFRChildData,
                            url: AreaFieldReportsChildAndParentURL,
                            request: {
                                AreaFieldReportId: request.id
                            }
                        })), dispatch(getByIdAPI({
                            key: AreaFieldReportsKeys.getHistoryData,
                            url: AreaFieldReportsHistoryURL,
                            request: HistoryReq
                        })), dispatch(getListAPI({
                            key: "getDealerIdList",
                            url: DealerIdListURL(request === null || request === void 0 ? void 0 : request.id),
                            request: request
                        }))])];
            case 1:
                _d = _e.sent(), res = _d[0], ChildAndParentData = _d[1], HistoryData = _d[2], DealerIdList = _d[3];
                FileAttachments = __spreadArray([], ((res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.value) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.data) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.Attachments) || []), true);
                return [2 /*return*/, _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value), {}, {
                        data: _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 || (_res$payload6 = _res$payload6.value) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.data), {}, {
                            ParamsBeforeRepairExpanded: true,
                            ParamsWhileRepairDataExpanded: true,
                            childFFR: ChildAndParentData === null || ChildAndParentData === void 0 || (_ChildAndParentData$p = ChildAndParentData.payload) === null || _ChildAndParentData$p === void 0 || (_ChildAndParentData$p = _ChildAndParentData$p.value) === null || _ChildAndParentData$p === void 0 ? void 0 : _ChildAndParentData$p.data,
                            history: HistoryData === null || HistoryData === void 0 || (_HistoryData$payload = HistoryData.payload) === null || _HistoryData$payload === void 0 || (_HistoryData$payload = _HistoryData$payload.value) === null || _HistoryData$payload === void 0 ? void 0 : _HistoryData$payload.data,
                            dealerIdList: DealerIdList === null || DealerIdList === void 0 || (_DealerIdList$payload = DealerIdList.payload.value) === null || _DealerIdList$payload === void 0 ? void 0 : _DealerIdList$payload.data,
                            FileAttachments: FileAttachments
                        })
                    })];
        }
    });
}); };
export var FieldFailureReportsGetAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _res$payload8, _res$payload9, _ChildAndParentData$p2, _HistoryData$payload2, _a, key, _b, request, _c, url, res, req, HistoryReq, ChildAndParentData, HistoryData, FileAttachments;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsDetailGetByIdAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                req = {
                    ParentFFRId: request.id
                };
                HistoryReq = {
                    FieldFailureReportId: request.id
                };
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.getFFRChildData,
                        url: FieldFailureReportsChildURL,
                        request: req
                    }))];
            case 2:
                ChildAndParentData = _d.sent();
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.getHistoryData,
                        url: FieldFailureReportsHistoryURL,
                        request: HistoryReq
                    }))];
            case 3:
                HistoryData = _d.sent();
                FileAttachments = __spreadArray([], ((res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.value) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.data) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.Attachments) || []), true);
                console.log("history", HistoryData);
                console.log("child", ChildAndParentData);
                return [2 /*return*/, _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value), {}, {
                        data: _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 || (_res$payload9 = _res$payload9.value) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.data), {}, {
                            ParamsBeforeRepairExpanded: true,
                            ParamsWhileRepairDataExpanded: true,
                            childFFR: ChildAndParentData === null || ChildAndParentData === void 0 || (_ChildAndParentData$p2 = ChildAndParentData.payload) === null || _ChildAndParentData$p2 === void 0 || (_ChildAndParentData$p2 = _ChildAndParentData$p2.value) === null || _ChildAndParentData$p2 === void 0 ? void 0 : _ChildAndParentData$p2.data,
                            history: HistoryData === null || HistoryData === void 0 || (_HistoryData$payload2 = HistoryData.payload) === null || _HistoryData$payload2 === void 0 || (_HistoryData$payload2 = _HistoryData$payload2.value) === null || _HistoryData$payload2 === void 0 ? void 0 : _HistoryData$payload2.data,
                            FileAttachments: FileAttachments
                        })
                    })];
        }
    });
}); };
export var ASMRemarksAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$request, _params$request2, _params$request3, _params$request4, _params$request5, _params$request6, _params$request7, _params$request8, _params$request9, _a, key, _b, request, _c, url, RequestData, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.ASMRemarks : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? FFRAreaRemarks() : _c;
                RequestData = {
                    OrganizationId: params === null || params === void 0 || (_params$request = params.request) === null || _params$request === void 0 ? void 0 : _params$request.OrganizationId,
                    BranchId: params === null || params === void 0 || (_params$request2 = params.request) === null || _params$request2 === void 0 ? void 0 : _params$request2.branchId,
                    StatusId: params === null || params === void 0 || (_params$request3 = params.request) === null || _params$request3 === void 0 ? void 0 : _params$request3.StatusId,
                    DocumentDate: params === null || params === void 0 || (_params$request4 = params.request) === null || _params$request4 === void 0 ? void 0 : _params$request4.DocumentDate,
                    DocumentName: params === null || params === void 0 || (_params$request5 = params.request) === null || _params$request5 === void 0 ? void 0 : _params$request5.DocumentName,
                    UserId: params === null || params === void 0 || (_params$request6 = params.request) === null || _params$request6 === void 0 ? void 0 : _params$request6.UserId,
                    FieldFailureReports: [{
                            FieldFailureReportId: params === null || params === void 0 || (_params$request7 = params.request) === null || _params$request7 === void 0 ? void 0 : _params$request7.id,
                            IsParent: "1",
                            Remark: params === null || params === void 0 || (_params$request8 = params.request) === null || _params$request8 === void 0 ? void 0 : _params$request8.Remarks,
                            UserId: params === null || params === void 0 || (_params$request9 = params.request) === null || _params$request9 === void 0 ? void 0 : _params$request9.UserId
                        }]
                };
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: RequestData
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, {}];
        }
    });
}); };
export var getPriorityPickList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "repairTypeList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? PriorityPickListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getCategoryPickList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "repairTypeList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? CategoryPickListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getDealerIdList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getDealerIdList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? DealerIdListURL(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getFieldFailureReportsUpdateAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$ParamsAfterR, _request$ParamsBefore, _res$payload10, _a, key, _b, request, _c, url, paramsAfterRepairData, paramsBeforeRepairData, reqData, res, _res$payload11;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? FieldFailureReportsKeys.update : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsDetailUpdateByIdAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                paramsAfterRepairData = (_request$ParamsAfterR = request.ParamsAfterRepairData) === null || _request$ParamsAfterR === void 0 ? void 0 : _request$ParamsAfterR.map(function (item) {
                    var _item$IsBeforeRepair;
                    return _objectSpread(_objectSpread({}, item), {}, {
                        IsBeforeRepair: (_item$IsBeforeRepair = item.IsBeforeRepair) !== null && _item$IsBeforeRepair !== void 0 ? _item$IsBeforeRepair : 0
                    });
                });
                paramsBeforeRepairData = (_request$ParamsBefore = request.ParamsBeforeRepairData) === null || _request$ParamsBefore === void 0 ? void 0 : _request$ParamsBefore.map(function (item) {
                    var _item$IsBeforeRepair2;
                    return _objectSpread(_objectSpread({}, item), {}, {
                        IsBeforeRepair: (_item$IsBeforeRepair2 = item.IsBeforeRepair) !== null && _item$IsBeforeRepair2 !== void 0 ? _item$IsBeforeRepair2 : 1
                    });
                });
                reqData = _objectSpread(_objectSpread({}, request), {}, {
                    ParamsAfterRepairData: paramsAfterRepairData,
                    ParamsBeforeRepairData: paramsBeforeRepairData,
                    Attachments: request === null || request === void 0 ? void 0 : request.FileAttachments.map(function (item) { return _objectSpread({}, item); })
                });
                return [4 /*yield*/, dispatch(updateAPI({
                        key: key,
                        url: url,
                        request: reqData
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload10 = res.payload) !== null && _res$payload10 !== void 0 && _res$payload10.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Updated Successfully",
                        type: "success"
                    }));
                    /**
                     * Navigating user to catalog dashboard
                     */
                    window.location.href = "/areaFieldReports/ffr";
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.error,
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
        }
    });
}); };
export var getAreaFieldFailureReportsUpdateAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, reqData, _res$payload12, res, _res$payload13;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.update : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AreaFieldReportsUpdateURL(request === null || request === void 0 ? void 0 : request.id) : _c;
                reqData = _objectSpread(_objectSpread({}, request), {}, {
                    Attachments: request === null || request === void 0 ? void 0 : request.FileAttachments.map(function (item) { return _objectSpread({}, item); })
                });
                if (!(request !== null && request !== void 0 && request.IsSubmit)) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(updateAPI({
                        key: key,
                        url: url,
                        request: reqData
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload12 = res.payload) !== null && _res$payload12 !== void 0 && _res$payload12.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Updated Successfully",
                        type: "success"
                    }));
                    window.location.href = "/areaFieldReports/afr";
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.error,
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
            case 2: return [2 /*return*/, []];
        }
    });
}); };
export var AreaFieldFailureReportSubmitAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload14, _a, key, _b, request, _c, url, res, _request$onClose, _res$payload15;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.update : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AreaFieldFailureReportSubmitAPI : _c;
                return [4 /*yield*/, dispatch(updateAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload14 = res.payload) !== null && _res$payload14 !== void 0 && _res$payload14.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Updated Successfully",
                        type: "success"
                    }));
                    /**
                     * Navigating user to catalog dashboard
                     */
                    request === null || request === void 0 || (_request$onClose = request.onClose) === null || _request$onClose === void 0 || _request$onClose.call(request);
                    window.location.href = "/areaFieldReports";
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.error,
                        type: "error"
                    }));
                }
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
        }
    });
}); };
export var areaFieldReportsCountAPI = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _open$payload$value$c, _open$payload, _grouped$payload$valu, _grouped$payload, _submitted$payload$va, _submitted$payload, _reverted$payload$val, _reverted$payload, _resubmitted$payload$, _resubmitted$payload, _closed$payload$value, _closed$payload, _a, open, grouped, submitted, reverted, resubmitted, closed, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    // dispatch(getByIdAPI({
                    //     key: AreaFieldReportsKeys.count,
                    //     url: AreaFieldReportsPagingURL
                    // })),
                    dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: AreaFieldReportsPagingURL,
                        request: {
                            status: "Open"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: AreaFieldReportsPagingURL,
                        request: {
                            status: "Grouped"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: AreaFieldReportsPagingURL,
                        request: {
                            status: "SubmittedByASM"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: AreaFieldReportsPagingURL,
                        request: {
                            status: "ResentByPSG"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: AreaFieldReportsPagingURL,
                        request: {
                            status: "ResubmittedToPSG"
                        }
                    })), dispatch(getByIdAPI({
                        key: AreaFieldReportsKeys.count,
                        url: AreaFieldReportsPagingURL,
                        request: {
                            status: "Closed"
                        }
                    }))
                ])];
            case 1:
                _a = _b.sent(), open = _a[0], grouped = _a[1], submitted = _a[2], reverted = _a[3], resubmitted = _a[4], closed = _a[5];
                result = dispatch(setState({
                    key: AreaFieldReportsKeys.count,
                    value: {
                        open: (_open$payload$value$c = open === null || open === void 0 || (_open$payload = open.payload) === null || _open$payload === void 0 || (_open$payload = _open$payload.value) === null || _open$payload === void 0 ? void 0 : _open$payload.count) !== null && _open$payload$value$c !== void 0 ? _open$payload$value$c : 0,
                        grouped: (_grouped$payload$valu = grouped === null || grouped === void 0 || (_grouped$payload = grouped.payload) === null || _grouped$payload === void 0 || (_grouped$payload = _grouped$payload.value) === null || _grouped$payload === void 0 ? void 0 : _grouped$payload.count) !== null && _grouped$payload$valu !== void 0 ? _grouped$payload$valu : 0,
                        submitted: (_submitted$payload$va = submitted === null || submitted === void 0 || (_submitted$payload = submitted.payload) === null || _submitted$payload === void 0 || (_submitted$payload = _submitted$payload.value) === null || _submitted$payload === void 0 ? void 0 : _submitted$payload.count) !== null && _submitted$payload$va !== void 0 ? _submitted$payload$va : 0,
                        reverted: (_reverted$payload$val = reverted === null || reverted === void 0 || (_reverted$payload = reverted.payload) === null || _reverted$payload === void 0 || (_reverted$payload = _reverted$payload.value) === null || _reverted$payload === void 0 ? void 0 : _reverted$payload.count) !== null && _reverted$payload$val !== void 0 ? _reverted$payload$val : 0,
                        resubmitted: (_resubmitted$payload$ = resubmitted === null || resubmitted === void 0 || (_resubmitted$payload = resubmitted.payload) === null || _resubmitted$payload === void 0 || (_resubmitted$payload = _resubmitted$payload.value) === null || _resubmitted$payload === void 0 ? void 0 : _resubmitted$payload.count) !== null && _resubmitted$payload$ !== void 0 ? _resubmitted$payload$ : 0,
                        closed: (_closed$payload$value = closed === null || closed === void 0 || (_closed$payload = closed.payload) === null || _closed$payload === void 0 || (_closed$payload = _closed$payload.value) === null || _closed$payload === void 0 ? void 0 : _closed$payload.count) !== null && _closed$payload$value !== void 0 ? _closed$payload$value : 0
                    }
                }));
                return [2 /*return*/, result.payload.value];
        }
    });
}); };
export var areaFieldReportsPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload16, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AreaFieldReportsPagingURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload16 = res.payload) === null || _res$payload16 === void 0 ? void 0 : _res$payload16.value];
        }
    });
}); };
export var FFRMultipleRemarks = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.log("paramsss", params);
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.MultipleASMRemarks : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? FFRAreaRemarks() : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: params === null || params === void 0 ? void 0 : params.request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, {}];
        }
    });
}); };
export var FFRUpdateRemarks = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.ResendRemarks : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? UpdateRemarks() : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: params.request
                    }))];
            case 1:
                res = _d.sent();
                console.log("ressssupdate", res);
                return [2 /*return*/, {}];
        }
    });
}); };
export var SinglePopupRemarksCreate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.ResendRemarks : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? FFRAreaRemarks() : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: params.request
                    }))];
            case 1:
                res = _d.sent();
                console.log("ressssupdate", res);
                return [2 /*return*/, {}];
        }
    });
}); };
export var SinglePopupRemarksUpdate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.ResendRemarks : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? UpdateRemarks() : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: params.request
                    }))];
            case 1:
                res = _d.sent();
                console.log("ressssupdate", res);
                return [2 /*return*/, {}];
        }
    });
}); };
export var fieldFailureReportsPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload17, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AreaFieldReportsKeys.FFRPaging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? fieldFailureReportsPagingURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload17 = res.payload) === null || _res$payload17 === void 0 ? void 0 : _res$payload17.value];
        }
    });
}); };
// export const UploadAttachmentAPICall: APICallFunction = async (params) => {
//   const file = params?.request?.data;
//   if (!file) {
//     console.error("No file provided in request");
//     return null;
//   }
//   const fileSize = file?.size ?? file?.Size;
//   const requestData = {
//     AreaFieldReportId: params?.state?.id ?? params?.request?.id,
//     AttachmentId: "",
//     Size: fileSize,
//     IsDeleted: 0
//   };
//   const {
//     key = AreaFieldReportsKeys.update,
//     url = AreaFieldReportsCreateAttachment
//   } = params;
//   const uploadResponse = await dispatch(createAPI({ key, url, request: requestData }));
//   const attachmentId = uploadResponse.payload.value.data.AreaFieldReportCourierAttachmentId;
//   const schemaId = uploadResponse.payload.value.data.SchemaId
//   const uploadUrl = AreaFieldReportsAttachmentSingleValue(attachmentId, schemaId);
//   const singleValueKey = AreaFieldReportsKeys.getValue;
//   const finalResponse = await dispatch(uploadAttachmentAPI({
//     key: singleValueKey,
//     request: {
//       data: file,
//       systemname: 'AreaFieldReportsAttachment'
//     },
//     url: uploadUrl
//   }));
//   return finalResponse.payload.value;
// };
